<template>
	<div>
		<br>
		
		<div id="first-div-home" class="light-div">
			<h1 id="first-title-text" class="fs-1 fw-bold yellow-text">
				Nossa Aliança
				<small class="fs-2 yellow-text">Consultoria e Mentoria</small>
			</h1>

			<br>
			
			<h3 class="float-end">
				<p class="float-end yellow-text fs-4 m-0 p-2">A solução eficaz para a sua gestão</p>
			</h3>
		</div>

		<div id="second-div-home" class="dark-div">
			<div class="row align-items-center page-margin">
				<div id="second-div-card" class="col-7 mb-3 mb-sm-0 text-center rounded light-text fs-5 py-2" >
					A necessidade mais urgente do Varejo Alimentar é <strong>SE ORGANIZAR!</strong>
					<br>
					<br>
					Em meio a tantos desafios como rentabilizar e
					profissionalizar empresas, empresários e colaboradores,
					oferecemos um processo testado e aprovado na prática baseado
					em três valores fundamentais: 
					<br>
					<br>
					<div class="row align-items-center">
						<div class="col mb-3 bg-warning rounded mx-3">
							<b>MEDIR</b>
						</div>
						<div class="col mb-3 bg-warning rounded mx-3">
							<b>ATUAR</b>
						</div>
						<div class="col mb-3 bg-warning rounded mx-3">
							<b>ENVOLVER</b>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center p-0 col-5">
					<img src="@/assets/card-1.jpeg" alt="Card" class="img-fluid rounded col-11 col-sm-11 col-md-10 col-lg-7" id="card-1-img">
				</div>
			</div>
		</div>
		

		<div id="third-div" class="light-div">
			<div class="page-margin my-4 text-center dark-text fs-3">
				Desde a sua fundação, a Nossa Aliança Consultoria
				vem evoluindo suas práticas e metodologias, permitindo atender 
				os clientes através da agregação de novos segmentos como:
			</div>

			<div class="row d-flex justify-content-between mt-3 page-margin dark-text">
				<div class="col-sm-3 my-3 flex-fill">
				<div class="card w-auto border-2 bg-body-secondary">
				<div class="card-body text-center">
					<h5 class="card-title"><strong><b>LANCHONETES E RESTAURANTES</b></strong></h5>
					<div class="card-icon mt-3 mx-auto d-block d-flex rounded-circle bg-secondary bg-gradient m-2 p-3">
						<img src="@/assets/plate-icon.png" class="img-fluid" alt="icon">
					</div>
					<p class="card-text mt-3">
						Quando agregados na mesma área
						do supermercado, estes segmentos
						têm o poder de aumentar sua
						rentabilidade, além de fidelizarem
						ainda mais seus clientes
					</p>
				</div>
				</div>
				</div>

				<div class="col-sm-3 my-3 flex-fill">
				<div class="card w-auto border-2 bg-body-secondary">
				<div class="card-body text-center">
					<h5 class="card-title"><strong><b>ATACAREJO</b></strong></h5>
					<div class="card-icon mt-3 mx-auto d-block d-flex rounded-circle bg-secondary bg-gradient m-2 p-3">
						<img src="@/assets/house-icon.png" class="img-fluid" alt="icon">
					</div>
					<p class="card-text mt-3">
						Alimentos, bebidas, bombonieres,
						cafés, cosméticos, higiene pessoal,
						panificação, utilidades domésticas e
						cama, mesa e banho podem ser um
						grande aliado para gerar volume
						junto à indústria
					</p>
				</div>
				</div>
				</div>

				<div class="col-sm-3 my-3 flex-fill">
				<div class="card w-auto border-2 bg-body-secondary">
				<div class="card-body text-center">
					<h5 class="card-title"><strong><b>VAREJO EXPRESS</b></strong></h5>
					<div class="card-icon mt-3 mx-auto d-block d-flex rounded-circle bg-secondary bg-gradient m-2 p-4">
						<img src="@/assets/car-icon.png" class="img-fluid" alt="icon">
					</div>
					<p class="card-text mt-3">
						Modelo usado por grandes players.
						Imbatível quando implementado em
						cidades pequenas. Com baixo custo e
						margem satisfatória, pode se tornar o
						carro-chefe do seu negócio
					</p>
				</div>
				</div>
				</div>
			</div>
		</div>


		<div id="fourth-div" class="dark-div light-text">
			<h2 class="text-center"><b>Atividades Desenvolvidas</b></h2>
		
			<div class="accordion mt-4 page-margin" id="accordionActivities">
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
							Administrativo
						</button>
					</h2>
					<div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Reorganização administrativa, Definição de normas e procedimentos, Estudo de layout e planograma, Ajuste visando a gestão de categoria, Criação e adoção de fluxograma e organograma, Avaliação de salário x função, Criação do DHO (Desenvolvimento Humano para a Organização), Avaliação do quadro de pessoal, Revisão de contrato de prestação de serviços, Redefinição de estrutura administrativa.
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
							Financeiro X Controladoria
						</button>
					</h2>
					<div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Gestão de resultados, Análise de custos e despesas, Apuração de margens e rentabilidade, Reestruturação setorial, Definição de normas e procedimentos, Formação e constituição de fluxo de caixa, Avaliação de investimentos.
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
							Comercial
						</button>
					</h2>
					<div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Gestão de estoque, Gestão de compras, Gestão de perdas, Reestruturação de equipes, Avaliação de mercados (qualitativo), Avaliação de potenciais de mercado (quantitativo), Avaliação de market share, Análise de mix de produtos, Negociação com fornecedores.
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
							Palestras, Cursos e Treinamentos
						</button>
					</h2>
					<div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Palestras motivacionais e comerciais, Curso de formação operacional, Treinamentos comerciais (vendas, atendimento, administrativo e financeiro).
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
							Logística
						</button>
					</h2>
					<div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Verticalização de depósito, Definição de estrutura física, Apuração de custos de distribuição e entregas.
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
							Tecnologia da Informação
						</button>
					</h2>
					<div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Avaliação de ERP's (sistemas), Avaliação do banco de dados x estrutura mercadológica, Implantação de novos ERP's (sistema) e treinamento e capacitação de usuários.
						</div>
					</div>
				</div>
				<div class="accordion-item">
					<h2 class="accordion-header">
						<button class="accordion-button collapsed fs-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree">
							Avaliações
						</button>
					</h2>
					<div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionActivities">
						<div class="accordion-body">
							Marcas, Patrimonial, Novo território de atuação.
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HomeView'
}
</script>

<style scoped>
/* classes */
.container-fluid {
	padding: 0;
	margin: 0;
}

.card {
	height: 100%;
}

.accordion-button {
	background-color: #003867;
	color: #ffffff;
}
.accordion-button:not(.collapsed) {
    background-color: #ffd700; /* Cor de fundo quando o accordion está aberto */
    color: #003867; /* Cor do texto quando o accordion está aberto */
	font-weight: bold;
}
.accordion-button::after {
    filter: invert(0); /* Inverte a cor da seta */
}
.accordion-button.collapsed::after {
	filter: invert(1); /* Inverte a cor da seta */
}

.card-icon {
	aspect-ratio: 1 / 1;
	width: 70%;
}

/* ids */
#first-div-home {
	padding-top: 10%;
	padding-bottom: 13%;

	background-image: url('@/assets/bg-1.jpg');
	background-size: cover;
	background-position: center;
}
#first-div-home h1 {
	background-color: #003867;
	display: inline-block;
	padding: 10px;
	padding-left: 10%;
	padding-right: 70px;

	clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 0% 100%);
}
#first-div-home h3 {
    background-color: #003867;
    width: auto;
	padding-right: 10%;
	padding-left: 40px;

	clip-path: polygon(7.5% 0%, 100% 0%, 100% 100%, 0% 100%);
}

#second-div-card {
	background-color: #5d5b59;
}
</style>